import { monthsBetween, type Day } from '../core/calendar.ts';
import { add, dec, div, fromInt, mul, pow, type Decimal } from '../core/decimal.ts';

export const DEFAULT_APPRECIATION_PERCENT: Decimal = dec(3);

/**
 * Appreciation.overWholeMonths, the one appreciation rule (R5): value × (1 + rate/100/12)^m
 * with m = max(0, months), the power via Double.
 */
export const appreciateOverWholeMonths = (value: Decimal, annualRatePercent: Decimal, months: number): Decimal =>
  mul(value, pow(add(dec(1), div(div(annualRatePercent, dec(100)), dec(12))), fromInt(Math.max(0, months))));

/** Appreciation.value: appreciated over the whole calendar months from purchase to date (§2.2). */
export const appreciatedValue = (value: Decimal, annualRatePercent: Decimal, purchaseDate: Day, date: Day): Decimal =>
  appreciateOverWholeMonths(value, annualRatePercent, monthsBetween(purchaseDate, date));
